<template>
    <div class="vx-row relative">
        <div class="vx-col w-full" style="transition: all 0.3s">
            <vx-card>
                <vx-server-side-table
                    ref="usersTable"
                    class="user-table"
                    v-model="selected"
                    :fetch-data="$api.users.fetch"
                    :columns="columns"
                    enable-search
                    paginate
                >
                    <template v-slot:Actions="{ row }">
                        <div class="flex flex-inline">
                            <vx-action-icon
                                :disabled="row.active"
                                icon="CheckCircleIcon"
                                color="success"
                                tooltip="Activate User"
                                class="mr-3"
                                @click="activate(row)"
                            />
                            <vx-action-icon
                                :disabled="!row.active"
                                icon="XCircleIcon"
                                color="danger"
                                tooltip="Deactivate User"
                                @click="deactivate(row)"
                            />
                        </div>
                    </template>
                </vx-server-side-table>
            </vx-card>
        </div>
    </div>
</template>

<script>
import UserLineDetail from './UserLineDetail.vue'
import mixin from '../../crm/apps/tableMixin'
import { mapGetters } from 'vuex'
import UserAvatar from '../../../components/project/UserProfiles/UserAvatar.vue'

export default {
    name: 'user-table',
    mixins: [mixin],
    components: { UserLineDetail, UserAvatar },
    props: {
        filters: {
            type: Object
        }
    },
    data() {
        return {
            selectedUser: null,
            search_text: ''
        }
    },
    computed: {
        ...mapGetters({}),
        selected: {
            get() {
                return this.selectedUser
            },
            set(val) {
                this.selectedUser = val
                this.$router.push(`/admin/users/${val.id}`)
            }
        },
        columns() {
            return [
                {
                    title: 'ID',
                    value: 'id',
                    sort: 'id',
                    visible: this.userHasRole(['SuperUser'])
                },
                {
                    title: 'First Name',
                    value: 'firstName',
                    sort: 'firstName'
                },
                {
                    title: 'Last Name',
                    value: 'lastName',
                    sort: 'lastName'
                },
                {
                    title: 'Email Address',
                    value: 'emailAddress',
                    sort: 'emailAddress'
                },
                {
                    title: 'Active',
                    value: (v) => (v.active == 1 || v.active == true ? 'Yes' : 'No'),
                    sort: 'active'
                },
                {
                    title: 'Actions',
                    value: ''
                }
            ]
        }
    },
    methods: {
        async activate(user) {
            try {
                this.loading = true
                var response = await this.$api.users.activate(user.id)
                this.notifySuccess('Updated successfully', 'User Activated successfully.', 5000)
                this.$refs.usersTable.updateRecord({
                    ...user,
                    active: true
                })
            } catch (err) {
                this.notifyError('Error', `Error message: ${err}`, 5000)
            } finally {
                this.loading = false
            }
        },
        async deactivate(user) {
            try {
                this.loading = true
                var response = await this.$api.users.deactivate(user.id)
                this.notifySuccess('Updated successfully', 'User Deactivated successfully.', 5000)
                this.$refs.usersTable.updateRecord({
                    ...user,
                    active: false
                })
            } catch (err) {
                this.notifyError('Error', `Error message: ${err}`, 5000)
            } finally {
                this.loading = false
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/vuexy/_variables.scss';
</style>
